import { isEmpty, random, isNull } from 'lodash-es'

const colors = [
  '#1AB7EA',
  '#5C545F',
  '#FAC546',
  '#4A90E2',
  '#10BDE0',
  '#F8E71C',
  '#F16623',
  '#1D65F8',
  '#4A4A4A',
  '#50E3C2',
  '#93556C',
  '#D0021B',
  '#4AE285',
  '#ED8DED',
  '#1EC95B',
  '#FA4689',
]

const pick = (text) =>
  isEmpty(text) ? random(colors.length - 1) : text.charCodeAt(0) % colors.length

export const pickRandomColor = (text) => colors[pick(text)]

export const hex2rgba = (hex, alpha = 1) => {
  const normalizeHex = (hx) => (hx.length === 3 ? hx.repeat(2) : hx)
  const [r, g, b] = normalizeHex(hex)
    .match(/\w\w/g)
    .map((x) => parseInt(x, 16))
  return `rgba(${r},${g},${b},${alpha})`
}

const rgb2hex = (rgb, amendHash) => {
  let [r, g, b] = rgb

  r = (+r).toString(16)
  g = (+g).toString(16)
  b = (+b).toString(16)

  if (r.length === 1) {
    r = `0${r}`
  }
  if (g.length === 1) {
    g = `0${g}`
  }
  if (b.length === 1) {
    b = `0${b}`
  }

  if (amendHash) {
    // oxlint-disable-next-line typescript/restrict-plus-operands
    return r + g + b
  }

  return `#${r}${g}${b}`
}

export const rgbaToHex = (rgba, amendHash) => {
  const components = rgba.match(
    /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
  )

  if (isNull(components)) {
    return rgba
  }

  const [, r, g, b] = components

  return rgb2hex([r, g, b], amendHash)
}

export const getRgbaTransparency = (rgba) => {
  const components = rgba.match(
    /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
  )

  if (isNull(components)) {
    return rgba
  }

  return components[4]
}

export const getRelativeLuminance = (r, g, b) => {
  const [rs, gs, bs] = [r, g, b].map((c) => {
    const v = c / 255
    return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4
  })
  return 0.2126 * rs + 0.7152 * gs + 0.0722 * bs
}

export const isLightColor = (hex) => {
  const color = +`0x${hex.slice(1).replace(hex.length < 5 && /./g, '$&$&')}`

  const r = color >> 16
  const g = (color >> 8) & 255
  const b = color & 255

  // WCAG AA threshold for contrast ratio with black/white
  // The threshold where contrast(black) == contrast(white) is at luminance ~0.179
  return getRelativeLuminance(r, g, b) > 0.179
}

export const alterRgbaTransparency = (rgba, newTransparency) => {
  const components = rgba.match(
    /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
  )

  if (isNull(components)) {
    return rgba
  }

  const [, r, g, b] = components

  return `rgba(${r}, ${g}, ${b}, ${newTransparency})`
}

export const alterTransparency = (color, newTransparency) => {
  if (color.match(/^rgb/)) {
    return alterRgbaTransparency(color, newTransparency)
  }

  return hex2rgba(color, newTransparency)
}
